// Mock data for Pikachu Classes

export const brand = {
  name: 'Pikachu Classes',
  tagline: 'Experienced Home Tutors, Now Online Across Pan India',
  phone: '+91 88268 59799',
  phoneRaw: '918826859799',
  phone2: '+91 76191 88640',
  phone2Raw: '917619188640',
  email: 'pradhumantomar@pikachuclasses.com',
  email2: 'kumarshubham@pikachuclasses.com',
  address: 'Noida, Uttar Pradesh, India',
  colors: {
    yellow: '#F4B93E',
    red: '#E64B2B',
    teal: '#4FB3B8',
    navy: '#2C3E50',
    sky: '#7BB7DC',
    cream: '#FFF8EC'
  }
};

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Subjects', href: '#subjects' },
  { label: 'Classes', href: '#classes' },
  { label: 'Founders', href: '#founders' },
  { label: 'Pikachuians', href: '#pikachuians' },
  { label: 'Success', href: '#success' },
  { label: 'Register', href: '#register' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Contact', href: '#contact' }
];

export const founders = [
  {
    name: 'Pradhuman Tomar',
    role: 'Co-Founder',
    initials: 'PT',
    accent: '#E64B2B',
    focus: 'Business Development, Operations & Growth',
    bio: 'Pradhuman Tomar is the Co-Founder of Pikachu Classes and leads the organization\u2019s business development, operations, and strategic growth. He has played a key role in building the company\u2019s network of educators, strengthening parent relationships, and expanding the brand\u2019s reach. He is also a primary public contact for the organization, reflecting his active involvement in its day-to-day operations and growth initiatives.',
    tags: ['Operations', 'Partnerships', 'Growth', 'Parent Relations']
  },
  {
    name: 'Kumar Shubham',
    role: 'Co-Founder',
    initials: 'KS',
    accent: '#4FB3B8',
    focus: 'Academics, Innovation & Personalised Learning',
    bio: 'Kumar Shubham is the Co-Founder of Pikachu Classes and is responsible for driving the company\u2019s vision of delivering high-quality, personalized education. He focuses on academic excellence, innovation, and creating systems that help students receive one-to-one learning experiences tailored to their needs. Under his leadership, Pikachu Classes has expanded its personalized tutoring services for students across multiple educational boards.',
    tags: ['Academics', 'Curriculum', 'Innovation', 'Multi-Board']
  }
];

export const stats = [
  { value: '2252+', label: 'Happy Parents' },
  { value: '500+', label: 'Verified Tutors' },
  { value: '4.9', label: 'Google Rating' },
  { value: '10+', label: 'Years Experience' }
];

export const subjects = [
  { name: 'Mathematics', icon: 'Calculator', color: 'bg-[#F4B93E]', desc: 'From basic arithmetic to advanced calculus, algebra & geometry.' },
  { name: 'Science', icon: 'FlaskConical', color: 'bg-[#4FB3B8]', desc: 'Physics, Chemistry, Biology explained with real-world examples.' },
  { name: 'English', icon: 'BookOpen', color: 'bg-[#E64B2B]', desc: 'Grammar, literature, writing & spoken English mastery.' },
  { name: 'Hindi', icon: 'Languages', color: 'bg-[#7BB7DC]', desc: 'व्याकरण, साहित्य और लेखन कौशल का समग्र विकास।' },
  { name: 'Social Studies', icon: 'Globe2', color: 'bg-[#F4B93E]', desc: 'History, Geography, Civics & Economics made simple.' },
  { name: 'Computer Science', icon: 'Code2', color: 'bg-[#2C3E50]', textLight: true, desc: 'Programming, coding basics and computer fundamentals.' },
  { name: 'Accountancy', icon: 'Wallet', color: 'bg-[#4FB3B8]', desc: 'Journal entries, ledgers, balance sheets & final accounts.' },
  { name: 'Sanskrit', icon: 'ScrollText', color: 'bg-[#E64B2B]', desc: 'संस्कृत भाषा, व्याकरण एवं अनुवाद अभ्यास।' }
];

export const classLevels = [
  { level: 'Pre-KG to KG', desc: 'Playful learning, alphabets, numbers & rhymes.', badge: 'Starter' },
  { level: 'Class 1 – 5', desc: 'Strong foundation in Maths, English, EVS & Hindi.', badge: 'Primary' },
  { level: 'Class 6 – 8', desc: 'Concept-based learning aligned to CBSE / ICSE / State boards.', badge: 'Middle' },
  { level: 'Class 9 – 10', desc: 'Board preparation, sample papers, chapter-wise mastery.', badge: 'Secondary' },
  { level: 'Class 11 – 12', desc: 'PCM, PCB, Commerce & Humanities. Board + Entrance ready.', badge: 'Senior' },
  { level: 'Competitive Exams', desc: 'JEE / NEET / NTSE / Olympiads foundation coaching.', badge: 'Advanced' }
];

export const boards = ['CBSE', 'ICSE', 'IB', 'IGCSE', 'State Boards', 'NIOS'];

export const features = [
  { icon: 'HomeIcon', title: 'Learn from Home', desc: 'One-on-one attention in the comfort of your own home. No commute, no stress.' },
  { icon: 'BadgeCheck', title: 'Verified Tutors', desc: 'Every tutor is background-checked, interviewed & subject-tested before joining.' },
  { icon: 'Wallet', title: 'Affordable Fees', desc: 'Transparent, monthly plans — no hidden charges. Free demo class included.' },
  { icon: 'Clock', title: 'Flexible Timings', desc: 'Choose slots that fit your schedule. Weekends and late evenings available.' },
  { icon: 'Users', title: 'Match Guarantee', desc: 'Not happy with a tutor? We replace them — no questions asked.' },
  { icon: 'Laptop', title: 'Online + Offline', desc: 'Home tuition in Delhi NCR & online classes across Pan India.' }
];

export const steps = [
  { n: '01', title: 'Tell Us Your Need', desc: 'Share the class, subject, board & preferred timing over a quick call.' },
  { n: '02', title: 'Meet Your Tutor', desc: 'We match you with a shortlisted tutor. Book a FREE demo class.' },
  { n: '03', title: 'Start Learning', desc: 'Begin regular classes with progress tracking and monthly reviews.' }
];

export const testimonials = [
  {
    name: 'Anjali Sharma',
    role: 'Parent, Class 10 CBSE',
    text: 'My daughter was struggling with Maths. In just 3 months of Pikachu Classes, her scores jumped from 62 to 89. The tutor is patient and truly cares.',
    rating: 5
  },
  {
    name: 'Rakesh Verma',
    role: 'Parent, Class 8',
    text: 'Booking was smooth and the demo class helped us decide. The tutor arrives on time every single day. Highly recommended for Noida families.',
    rating: 5
  },
  {
    name: 'Priya Mehta',
    role: 'Parent, Class 12 PCM',
    text: 'Physics teacher from Pikachu Classes is exceptional. My son cleared JEE Mains with a great score. Grateful for the guidance.',
    rating: 5
  },
  {
    name: 'Suresh Kumar',
    role: 'Parent, Class 5',
    text: 'Affordable and reliable. My son actually enjoys his study time now. The teacher makes learning fun with real-life examples.',
    rating: 5
  },
  {
    name: 'Neha Gupta',
    role: 'Parent, Class 9 ICSE',
    text: 'We tried three tuition services before Pikachu Classes. This is by far the most professional. The replacement policy also gave us confidence.',
    rating: 5
  }
];

export const faqs = [
  { q: 'How does home tuition work?', a: 'After you share your requirements, we shortlist a verified tutor and schedule a FREE demo class at your home. Once you approve, regular classes begin as per your chosen timing.' },
  { q: 'What are your charges?', a: 'Fees depend on the class, subject and number of days per week. We keep our pricing affordable and transparent — you can get a personalised quote in a 2-minute call.' },
  { q: 'Do you provide online classes?', a: 'Yes. Pikachu Classes is now available online across Pan India. Home tuition (offline) is available in Delhi NCR — Noida, Ghaziabad, Delhi and Gurugram.' },
  { q: 'What if I don\'t like the tutor?', a: 'We offer a free tutor replacement — no questions asked. Your child\'s comfort and progress is our priority.' },
  { q: 'Which boards do you cover?', a: 'We cover CBSE, ICSE, IB, IGCSE, NIOS and all major State Boards, from Pre-KG to Class 12 and competitive exams.' },
  { q: 'How do I book a demo class?', a: 'Just call us at +91 88268 59799 or fill the enquiry form on this page. Our counsellor will call you back within 30 minutes.' }
];

export const heroImage = 'https://images.unsplash.com/photo-1629360021730-3d258452c425';
export const aboutImage = 'https://images.pexels.com/photos/5088181/pexels-photo-5088181.jpeg';
export const ctaImage = 'https://images.unsplash.com/photo-1560785496-3c9d27877182';
